import styled from 'styled-components'

import { media } from 'styles/media'

export const CalendarWrapper = styled.div`
  padding: 44px 0;

  ${media.md`
    padding: 31px 12px;
  `}

  // The booking calendar paints its own disabled-day visuals via data
  // attributes on each cell (solid grey for booked, white + dim text for
  // out-of-range, diagonal for check-in/out-only). rdp v9's default 0.5
  // opacity on disabled cells fades those backgrounds and makes booked
  // days look lighter than the diagonal triangle on adjacent check-in /
  // check-out days. Disable the rdp dimming so our per-state styling
  // carries the visual meaning at full strength.
  //
  // Drop the day-button border too — the booking calendar reads cleaner
  // without a 1px outline on every cell. The shared wrapper paints a
  // border-color on hover; with the border width at 0 the colour is a
  // no-op and we don't need to override the hover rule.
  .rdp-root {
    --rdp-disabled-opacity: 1;
    --rdp-day_button-border: 0;

    /* Align the calendar's outer edges (prev/next nav buttons + grid)
       with the CalendarHeader above, which sits at margin-left: 20px
       and width: calc(100% - 32px) inside CalendarWrapper. Vertical
       padding gives the grid breathing room between the header and the
       AvailabilityInfo legend rendered below. */
    padding: 20px 12px 20px 20px;
  }

  /* Reserve a baseline height on desktop so the modal doesn't jump when
     the AvailabilityInfo legend grows by a line ("The minimum booking
     is X nights" after a start is picked). rdp v9's animate prop
     handles the slide for month transitions; height changes are eased
     via the transition below so the legend doesn't snap when the grid
     gains/loses a week row. */
  ${media.md`
    .booking-calendar-rdp {
      min-height: 560px;
      transition: min-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  `}
`
